import { createContext, useContext, useState } from "react";
import axios from "axios";
import { getToken, setToken, clearToken } from "@/lib/api";

const AuthContext = createContext(null);
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function AuthProvider({ children }) {
  // Read from sessionStorage (falls back to localStorage for migration)
  const [token, setTokenState] = useState(() => getToken() || "");

  const isAuthenticated = !!token;

  const login = async (password) => {
    const res = await axios.post(`${API}/auth/login`, { password });
    const t = res.data.token;
    setToken(t);           // store in sessionStorage
    setTokenState(t);
  };

  const logout = () => {
    clearToken();          // remove from both storages
    setTokenState("");
  };

  return (
    <AuthContext.Provider value={{ token, isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
